import { useParams } from "react-router";
import { SampleType } from "@/services/backend/types";
import { SampleSetTable } from "./sample-set-table";
import { useShowDocumentationQuery } from "@/services/backend/documentations/service";
import { ArtefactNotReadyAlert } from "@/shared/service-manager/artefact/artefact-sheet";
import { useErrArtefactNotReady } from "@/shared/service-manager/artefact/err-artefact-not-ready";

export function SetOverviewIndexRoute() {
  const { documentationId } = useParams();
  const { data: doc } = useShowDocumentationQuery({ id: documentationId! });
  const immutable = !!doc?.documentation.immutable;
  const { notReadyError } = useErrArtefactNotReady();

  return (
    <div className="flex flex-col space-y-4">
      <ArtefactNotReadyAlert error={notReadyError} artefact="Documentation" />
      <SampleSetTable
        label="Oberflächenkeimproben"
        visibilityState={{
          airSamplerHoleCount: false,
          airSampler: false,
          samplingVolume: false,
        }}
        ownerId={documentationId!}
        ownerType="documentations.Documentation"
        sampleType={SampleType.SurfaceMicrobial}
        immutable={immutable}
      />
      <SampleSetTable
        label="Luftkeimproben"
        ownerId={documentationId!}
        ownerType="documentations.Documentation"
        sampleType={SampleType.AirMicrobial}
        immutable={immutable}
      />
    </div>
  );
}
